<template>
  <div :class="$style.box">
    <SectionTitle :class="$style.box__title">資料を表示</SectionTitle>
    <ul :class="$style.box__list">
      <li v-for="link in links" :key="link.text">
        <BookIcon />
        <RouterLink
          :to="link.to"
          :class="$style.link"
          :active-class="$style['link--active']"
        >
          <span :class="$style.link__text">{{ link.text }}</span>
        </RouterLink>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import SectionTitle from '@/components/atoms/SectionTitle.vue'
import type { InternalLinkType } from '@/types/app'
import BookIcon from '@/assets/images/icons/book.svg?component'

const links: InternalLinkType[] = [
  {
    text: 'パンフレット',
    to: {
      name: 'solicitorCloudDocumentsPamphlet',
    },
  },
  {
    text: '引受目安',
    to: {
      name: 'solicitorCloudDocumentsCoverage',
    },
  },
  {
    text: '営業資料',
    to: {
      name: 'solicitorCloudDocumentsSalesMaterial',
    },
  },
]
</script>

<style lang="scss" module>
.box {
  padding: 20px 0;
  border-radius: 10px;
  width: 100%;
  background-color: $color-surface-primary;

  &__title {
    font-size: 16px;
    padding: 0 20px;
  }

  &__list {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    padding: 20px 20px 0;
    border-top: 1px solid $color-border-low-emphasis;

    & > *:nth-child(n + 2) {
      margin-top: 10px;
    }

    li {
      display: flex;
      align-items: center;
    }
  }
}
</style>
